import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class ProfileTypes {
  static banks: IActionType = new ActionType('PROFILE/BANK');
  static accounts: IActionType = new ActionType('PROFILE/ACCOUNTS');
  static myProfile: IActionType = new ActionType('PROFILE/MY_PROFILE');
  static saveMyProfile: IActionType = new ActionType('PROFILE/SAVE');
  static addressByZipCode: IActionType = new ActionType('PROFILE/ADDRESS_BY_ZIP');
  static createAccount: IActionType = new ActionType('PROFILE/CREATE_ACCOUNT');
  static isNewbie: IActionType = new ActionType('PROFILE/IS_NEWBIE');
  static saveTourAction: IActionType = new ActionType('PROFILE/SAVE_TOUR_ACTION');
  static checkPassword: IActionType = new ActionType('PROFILE/CHECK_PASSWORD');
}

export default ProfileTypes;
